import addError from '../../../utils/error.jsx';

export function request(reportType, accountId, params) {
    return {
        type: 'REPORTS_RUN_REQUEST',
        reportType,
        accountId,
        params
    };
}

export function error(errors) {
    addError(errors);

    return {
        type: 'REPORTS_RUN_ERROR',
        errors
    };
}

export function finish(data) {
    return {
        type: 'REPORTS_RUN_FINISH',
        data
    };
}

export function clear() {
    return {
        type: 'REPORTS_RUN_CLEAR'
    };
}
